// extracted by mini-css-extract-plugin
export var avatarContainer = "_hi-0";
export var avatarTypingWave = "_hi-i";
export var gray = "_hi-f";
export var green = "_hi-c";
export var icon = "_hi-9";
export var image = "_hi-1";
export var lg = "_hi-6";
export var md = "_hi-5";
export var presenceDot = "_hi-b";
export var red = "_hi-d";
export var sm = "_hi-4";
export var status = "_hi-a";
export var typingDot = "_hi-h";
export var typingPill = "_hi-g";
export var xl = "_hi-7";
export var xs = "_hi-3";
export var xxl = "_hi-8";
export var xxs = "_hi-2";
export var yellow = "_hi-e";